import { render, staticRenderFns } from "./AddDoctorPopup.vue?vue&type=template&id=c0ef0e0c"
import script from "./AddDoctorPopup.vue?vue&type=script&lang=js"
export * from "./AddDoctorPopup.vue?vue&type=script&lang=js"
import style0 from "./AddDoctorPopup.vue?vue&type=style&index=0&id=c0ef0e0c&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports